module.exports = __webpack_public_path__ + "img/en.db25644a.png";